  <main id="main">
    <!-- ======= Refund Policy Section ======= -->
    <section id="services" class="services">
      <div class="container" data-aos="fade-up">
        <header class="section-header">
          <h1>Refund Policy</h1>
        </header>

        <p>If you are not happy with your purchase, we will accept a return of an unused product within 14 days. Once we receive the returned item, MALtech.co will provide a full refund (excluding shipping as we are unable to refund the initial shipping cost).</p>

        <h2>Please allow 1-2 weeks for your return to be processed.</h2>

        <p>Discounted items are not eligible for a return.</p>
        <p>MALtech.co will not issue refunds for products purchased through other entities, such as distributors or retail partners.</p>
        <p>Returned items must be delivered to us unused, in original packaging, and in the condition they were received. Returns that do not meet these conditions may not be eligible for a refund or may be subject to a restocking fee.</p>
        <p>We recommend using an insured and trackable mail service, as we cannot be held responsible for items damaged or lost in return shipment.</p>
        <p>We are unable to issue a refund without actual receipt of the item(s) or proof of return delivery.</p>
        <p>We aim to accept all returns. In the unlikely event that an item is returned in an unsuitable condition, we may have to send it back. All goods will be inspected on return.</p>
      </div>
    </section><!-- End Refund Policy Section -->
  </main><!-- End #main -->
